import styled from "styled-components";
import { Input, Menu, Typography   } from "antd";
import { CloseCircleFilled as AntCloseCircleFille } from "@ant-design/icons";
import { theme } from "../../../config";
import { TextEllipsis } from "../../atoms/TextEllipsis";
const { TextArea } = Input;
const { Text } = Typography;

export const Wrapper = styled.div`
  position: relative;
`;

export const Header = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  padding: 19px 0 8px 0;
  background: ${theme.colors.white};
  font-family: "Orkney Bold";
  color: ${theme.colors.custom.darkblue3};
`;

export const LinkFilesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 16px;
  overflow-y: auto;
  max-height: 100px;
  padding-top: 8px;
`;

export const LinkFileWrapper = styled.div`
  color: ${theme.colors.custom.darkblue4};
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
`;

export const LinkFileTitleWrapper = styled.div`
  cursor: pointer;
  color: ${theme.colors.custom.darkblue4};
  text-decoration:!important;
  width: 85%;
  &:hover {
    opacity: 0.5;
  }
`;

export const CloseIcon = styled(AntCloseCircleFille)`
  color: ${theme.colors.utilities.error};
  cursor: pointer;
  font-size: 18px;
  margin-right: 10px;
  &:hover {
    opacity: 0.5;
  }
`;

export const TextEllipsisWrapper = styled(TextEllipsis)`
  cursor: pointer;
  color: ${theme.colors.custom.darkblue4};
  text-decoration: underline;
  width: calc(100% - 40px);
  &:hover {
    opacity: 0.5;
  }
`;

export const DropdownWrapper = styled.div`
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MenuWrapper = styled(Menu)` 
  padding: 6px 0px;
`;

export const MenuItemWrapper = styled(Menu.Item)`
  padding-left: 18px;
`;
